import React from 'react';
import Container from 'gatsby-theme-core/src/components/container';
import Background from '../background/index';
import useBlocks from '../blocks/use-blocks';
import getBlock from '../blocks/get-block-for-section';
import ContentThemeProvider from '../content-theme';
import PaddingWrapper from './padding-wrapper';
import Wrapper from './wrapper';
import Auth from './auth';

const ConditionalDesktopBackground = ({ desktopBackground, size, children }) => {
  if (!desktopBackground) {
    return children;
  }
  return (
    <Background
      disableOnMobile
      $size={size}
      {...desktopBackground}
    >
      {children}
    </Background>
  );
};
const ConditionalContainer = ({
  container,
  imageConstrain = false,
  onImageConstrain = false,
  children,
}) => {
  if (container === 'none' && !imageConstrain) {
    return children;
  }
  return (
    <Container
      small={container === 'normal'}
      $extraSmall={container === 'small'}
      $noPadding={imageConstrain}
      $doublePaddingOnMd={onImageConstrain}
    >
      {children}
    </Container>
  );
};

const Section = ({
  // id,
  background,
  desktopBackground,
  blocks,
  contentTheme = 'dark',
  size = 'normal',
  padding = 'normal',
  container = 'normal',
  onlyForAuthenticatedUsers = false,
}) => {
  const blockComponents = useBlocks(blocks, getBlock);
  const imageConstrain = background?.imagePosition === 'container';
  return (
    <Auth onlyForAuthenticatedUsers={onlyForAuthenticatedUsers}>
      <ContentThemeProvider
        contentTheme={contentTheme}
      >
        <ConditionalContainer container="none" imageConstrain={imageConstrain}>
          <Background
            $size={size}
            {...background}
          >
            <ConditionalDesktopBackground
              size={size}
              desktopBackground={desktopBackground}
            >
              <PaddingWrapper padding={padding}>
                <ConditionalContainer container={container} onImageConstrain={imageConstrain}>
                  <Wrapper>
                    {blockComponents}
                  </Wrapper>
                </ConditionalContainer>
              </PaddingWrapper>
            </ConditionalDesktopBackground>
          </Background>
        </ConditionalContainer>
      </ContentThemeProvider>
    </Auth>
  );
};

export default Section;
